import { InfoIcon } from "../../../assets/icons";
import SummaryReadOnlyField from "./SummaryReadOnlyField";
import { BulkParseStatus } from "./constants";

type BulkParseSummaryState = Readonly<{
  status: BulkParseStatus;
  totalAmount?: number;
  numberOfInvoices?: number;
}>;

type BulkDrawdownSummaryFieldsProps = Readonly<{
  currency: string;
  isIdle: boolean;
  bulkParseState: BulkParseSummaryState;
}>;

export function BulkDrawdownSummaryFields(
  props: BulkDrawdownSummaryFieldsProps
) {
  const { currency, isIdle, bulkParseState } = props;
  let bulkTotalAmountDisplay = "";
  if (!isIdle && bulkParseState.totalAmount != null) {
    bulkTotalAmountDisplay = bulkParseState.totalAmount.toLocaleString();
  }

  const tentativeAmountText =
    bulkParseState.totalAmount != null
      ? bulkParseState.totalAmount.toLocaleString()
      : "<amount>";

  const totalName = isIdle ? "bulkTotalAmountIdle" : "bulkTotalAmount";
  const countName = isIdle
    ? "bulkNumberOfInvoicesIdle"
    : "bulkNumberOfInvoices";

  return (
    <>
      <div className="cx-mt-4 cx-grid cx-grid-cols-1 md:cx-grid-cols-2 cx-gap-4">
        <SummaryReadOnlyField
          label={`Total drawdown amount <${currency}>`}
          inputProps={{
            name: totalName,
            value: bulkTotalAmountDisplay,
            ...(isIdle ? { placeholder: "—" } : {}),
          }}
          tick={
            !isIdle &&
            bulkParseState.status === BulkParseStatus.SUCCESS &&
            !!bulkParseState.totalAmount
          }
        />
        <SummaryReadOnlyField
          label="Number of invoices"
          inputProps={{
            name: countName,
            value: isIdle ? "" : bulkParseState.numberOfInvoices ?? "",
            ...(isIdle ? { placeholder: "—" } : {}),
          }}
          tick={
            !isIdle &&
            bulkParseState.status === BulkParseStatus.SUCCESS &&
            !!bulkParseState.numberOfInvoices
          }
        />
      </div>
      <div className="cx-mt-3 cx-flex cx-items-start cx-gap-2">
        <InfoIcon
          width={18}
          height={18}
          className="cx-mt-0.5 cx-flex-shrink-0 cx-text-[#0064FF]"
          aria-hidden
        />
        <p className="cx-text-sm cx-text-gray-500">
          {`Tentative total drawdown amount is ${currency} `}
          <span>{tentativeAmountText}</span>
          {`. The final disbursed amount will be confirmed at the time of disbursement based on the applicable exchange rate.`}
        </p>
      </div>
    </>
  );
}
